var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorChartLineMultilineOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 18.5L2 17.05l7.5-7.5 4 4 2.9-3.25c-.85-1-1.85-1.792-3-2.375-1.15-.584-2.417-.875-3.8-.875-1.183 0-2.3.22-3.35.663-1.05.441-2 1.037-2.85 1.787L2 8.05a12.043 12.043 0 013.475-2.2c1.283-.534 2.658-.8 4.125-.8 1.633 0 3.142.329 4.525.987A11.12 11.12 0 0117.75 8.8l2.85-3.25L22 7l-3 3.4c.55.883.996 1.841 1.338 2.875.341 1.033.562 2.125.662 3.275h-2c-.1-.834-.27-1.63-.512-2.388A11.647 11.647 0 0017.55 12l-3.95 4.45-4.1-4.05-6.1 6.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorChartLineMultilineOutline);
export default __webpack_public_path__ + "b0998f9d1b6d388316c7f9e69569993e.svg";
export { ForwardRef as ReactComponent };